import { render, staticRenderFns } from "./ScrollPosition.vue?vue&type=template&id=a3912e96&"
import script from "./ScrollPosition.vue?vue&type=script&lang=js&"
export * from "./ScrollPosition.vue?vue&type=script&lang=js&"
import style0 from "./ScrollPosition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports